import { render, staticRenderFns } from "./customerEdit.vue?vue&type=template&id=f7af5046&"
import script from "./customerEdit.vue?vue&type=script&lang=js&"
export * from "./customerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports